<div class="close-button">
  <button class="clear-transparent" mat-dialog-close>
    <span class="icon-close"></span>
  </button>
</div>

<mat-dialog-content class="mat-typography">
  <ng-container *ngIf="!isVerification">
    <h4 class="text-center">
      {{ "pages.wallet.recheck-withdraw" | translate }}
    </h4>
    <div class="well mb-3">
      <p>
        {{ "pages.wallet.amount" | translate }}<br />
        <strong>Rp {{ ui.currencyFormat(data.amount, locale) }}</strong>
      </p>
      <p class="mt-2">
        {{ "pages.wallet.account" | translate }}<br />
        <strong>{{ data.bankName }}</strong> <br />
        <strong>{{ data.accountNumbers }} </strong><br />
        <strong>a/n. {{ data.onBehalfOf }}</strong>
      </p>
    </div>
    <p>{{ "pages.wallet.withdraw-guide" | translate }}</p>
  </ng-container>

  <ng-container *ngIf="isVerification">
    <form [formGroup]="verifyFG">
      <h4 class="text-center font-weight-bold">
        Verifikasi Two-Factor Authentication
      </h4>
      <div class="well mb-3">
        <div class="form-group">
          <label for="verifyCode">Kode Verifikasi</label>
          <input
            id="verifyCode"
            formControlName="verifyCode"
            class="form-control"
            aria-describedby="Kode Verifikasi"
            placeholder="Masukkan kode..."
            autocomplete="off"
          />
        </div>
      </div>

      <p class="text-center">
        Belum menerima kode?
        <span
          (click)="handleResend()"
          [ngClass]="{ 'font-weight-bold': !displayTime }"
        >
          {{ displayTime ? displayTime + " untuk kirim ulang" : "Kirim Ulang" }}
        </span>
      </p>
    </form>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <ng-container *ngIf="!isVerification">
    <button
      cdkFocusInitial
      mat-button
      class="primary-button big-button mb-2"
      (click)="send()"
    >
      {{ "pages.wallet.withdraw-confirmation" | translate }}
    </button>
    <button
      [mat-dialog-close]="0"
      mat-button
      mat-dialog-close
      class="clear-button big-button"
    >
      {{ "common.cancel" | translate }}
    </button>
  </ng-container>
  <ng-container *ngIf="isVerification">
    <button
      mat-button
      class="primary-button big-button mb-2"
      (click)="verify()"
      [disabled]="isLoadingWithdraw"
    >
      {{ isLoadingWithdraw ? "Memproses..." : "Verifikasi" }}
    </button>
  </ng-container>
</mat-dialog-actions>
